let modal;

export const setTopLevelModal = (modalRef) => {
  modal = modalRef;
};

export const showModal = (
  title, children, renderHtml, bodyStyle, textConfirm = 'Aceptar', showConfirm = false,
  actionConfirm = null, textCancel = 'Cerrar', showCancel = true, actionCancel = null,
) => {
  modal.showModal(
    title, children, renderHtml, bodyStyle, textConfirm, showConfirm,
    actionConfirm, textCancel, showCancel, actionCancel,
  );
};

export const hideModal = (callback = null) => {
  modal.hideModal(callback);
};



// WEBPACK FOOTER //
// ./src/common/global/modal/index.js